import React, { useState } from 'react'
import Navbar from '../../components/Navbar'
import Modal from '../../components/Support/Modal'
import { motion } from 'framer-motion'
import TicketForm from '../../components/Support/TicketForm'
import ContactCards from '../../components/Support/ContactCards'

const Support = () => {
  const [modalType, setModalType] = useState(null);
  const [showTicketForm, setShowTicketForm] = useState(true);

  const openModal = (type) => setModalType(type);
  const closeModal = () => setModalType(null);

  return (
    <div>
      <Navbar page={"Support"} />
      <div className="px-4 py-8 min-h-screen bg-white md:px-8">
        <div className="mx-auto max-w-6xl">
          {/* Header Section */}
          <div className="flex justify-center pb-4 mb-12 space-x-8 border-b">
            <motion.button
              whileHover={{ scale: 1.05 }}
              className={`pb-2 text-gray-600 border-b-2 ${showTicketForm ? 'text-pink-500 border-pink-500' : 'border-transparent hover:border-gray-300'}`}
              onClick={() => setShowTicketForm(true)}
            >
              TICKET
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              className={`pb-2 text-gray-600 border-b-2 ${!showTicketForm ? 'text-pink-500 border-pink-500' : 'border-transparent hover:border-gray-300'}`}
              onClick={() => setShowTicketForm(false)}
            >
              CONTACT US
            </motion.button>
          </div>

          {showTicketForm ? (
            <TicketForm />
          ) : (
            <ContactCards openModal={openModal} />
          )}
        </div>
      </div>
      <Modal 
        isOpen={modalType !== null}
        onClose={closeModal}
        type={modalType}
      />
    </div>
  );
};

export default Support